"use client";

import { DEFAULT_SEARCH_ENTRIES_PER_PAGE, SEARCH_PARAMS } from "@/globals";
import { PaginationView } from "@/views/pagination.view";

type SearchModulePaginationProps = {
    baseURL: {
        context: "static" | "dynamic";
        dynamicPath: string;
        staticPath: string;
    };
    currentSearchString: string;
    hash: string;
    pageNumber: number;
    totalResults: number;
};

export const SearchModulePaginationView = ({
    pageNumber,
    totalResults,
    currentSearchString,
    hash,
    baseURL,
}: SearchModulePaginationProps) => {
    const params = new URLSearchParams(currentSearchString);

    return (
        <PaginationView
            getPageURL={(p) => {
                if (baseURL.context === "dynamic") {
                    params.set(SEARCH_PARAMS.page, p.toString());
                    return baseURL.dynamicPath + "?" + params.toString() + hash;
                } else {
                    return baseURL.staticPath + "/seite/" + p.toString() + hash;
                }
            }}
            pageNumber={pageNumber}
            pageCount={Math.ceil(
                totalResults /
                    parseInt(
                        params.get(SEARCH_PARAMS.entries) ??
                            DEFAULT_SEARCH_ENTRIES_PER_PAGE.toString(),
                    ),
            )}
        />
    );
};
